export default "__VITE_ASSET__BN5Ttlv9__"